export const SUB_STATUS = {
  trial: { label: "Essai", cls: "bg-accent-50 text-accent-800 border-accent-200", dot: "bg-accent-500" },
  active: { label: "Actif", cls: "bg-green-50 text-green-700 border-green-200", dot: "bg-green-500" },
  payment_pending: { label: "Paiement en attente", cls: "bg-orange-50 text-orange-700 border-orange-200", dot: "bg-orange-500" },
  suspended: { label: "Suspendu", cls: "bg-red-50 text-red-700 border-red-200", dot: "bg-red-500" },
  cancelled: { label: "Résilié", cls: "bg-slate-100 text-slate-600 border-slate-200", dot: "bg-slate-400" },
};

export const INV_STATUS = {
  draft: { label: "Brouillon", cls: "bg-slate-100 text-slate-600 border-slate-200" },
  issued: { label: "Émise", cls: "bg-accent-50 text-accent-800 border-accent-200" },
  paid: { label: "Payée", cls: "bg-green-50 text-green-700 border-green-200" },
  unpaid: { label: "Impayée", cls: "bg-red-50 text-red-700 border-red-200" },
  cancelled: { label: "Annulée par avoir", cls: "bg-slate-100 text-slate-500 border-slate-200" },
};

export const METHOD_LABEL = { none: "À définir", card: "Carte bancaire", sepa: "Prélèvement SEPA", transfer: "Virement", cheque: "Chèque", other: "Autre" };

export const eur = (x) => `${Number(x || 0).toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`;
